import React, { useEffect, useRef, useState } from "react";
import {
  Background,
  Wrap,
  Header,
  CloseButton,
  Form,
  SubmitButton,
  InputWrap,
  Info,
  Label,
} from "./styled";
import useUsersStore from "../../../../../hooks/useUsersStore";
import useModalStore from "../../../../../hooks/useModalStore";
import userProfileDef from "images/sports/common/user-profile-def.png";
import Url from "environment";

const PowerChatInput = ({
  viewChatInput,
  setViewChatInput,
  postCheerComment,
}) => {
  const modalStore = useModalStore();
  const userStore = useUsersStore();
  const { profile_image_path, nick, certify, is_admin } = userStore.data;
  const [text, setText] = useState("");

  const onSubmit = (event) => {
    event.preventDefault();
    if (text.length === 0) {
      alert("메세지 입력하세요.");
      return;
    }
    if (userStore.data.id === null) {
      modalStore.goLoginModal({ message: "로그인이 필요한 서비스입니다." });
      return;
    }
    if (!is_admin) {
      if (!certify.is_phone_certify) {
        alert("휴대폰 인증 후 사용이 가능 합니다.");
        return;
      }
    }

    const param = {
      content: text,
      device: "WEB",
      messageType: "POWER_CHAT",
    };

    postCheerComment(param).then((res) => {
      if (res.status === 200) {
        setText("");
        setViewChatInput(false);
      } else {
        modalStore.openAlertModal({
          message: res.data.message,
        });
      }
    });
  };

  return (
    <Background view={viewChatInput} onClick={() => setViewChatInput(false)}>
      <Wrap view={viewChatInput} onClick={(event) => event.stopPropagation()}>
        <Header>
          <h2>파워챗 보내기</h2>
          <p>파워챗을 보내면 응원 메뉴 상단에 고정됩니다.</p>
          <CloseButton onClick={() => setViewChatInput(false)} />
        </Header>
        <Form onSubmit={onSubmit}>
          <InputWrap>
            <Info>
              <img
                src={
                  profile_image_path
                    ? `${Url.thumbCrop}/112x112${profile_image_path.replace(
                        "data/",
                        ""
                      )}`
                    : userProfileDef
                }
                onError={(event) => {
                  event.target.src = userProfileDef;
                }}
              />
              <div>
                <span>{nick}</span>
                <p>100,000포인트가 소모됩니다.</p>
              </div>
            </Info>
            <Label>
              <input
                type={"text"}
                value={text}
                onChange={(event) => setText(event.target.value)}
                placeholder={"메세지를 입력해 관심을 받아보세요."}
              />
            </Label>
          </InputWrap>
          <SubmitButton type={"submit"}>파워챗 보내기</SubmitButton>
        </Form>
      </Wrap>
    </Background>
  );
};

export default PowerChatInput;
